<!-- BCT: Modified for EP-97 -->
<template>
  <div>
    <div style="position: absolute; top:0; bottom: 64px; width: 100%;">
      <v-card flat class="edit-panel" style="height: 100%; overflow: auto">
          <div class="border-bottom">
            <p v-if="key === 'available_date'" class="font-regular mt-4 px-5  hb-text-night-light">Select the date to make spaces available.</p>
            <p v-if="key === 'category_id'" class="font-regular mt-4 px-5  hb-text-night-light"> Select {{ $t('website category') }} for the spaces.</p>
            <p v-if="key === 'floor'" class="font-regular mt-4 px-5  hb-text-night-light">Set floor value for the spaces.</p>
            <p v-if="key === 'area_id'" class="font-regular mt-4 px-5  hb-text-night-light">Set area for the spaces.</p>
            <p v-if="!['available_date', 'category_id', 'floor','area_id'].includes(key)" class="font-regular mt-4 px-5  hb-text-night-light">Select one of the following options.</p>
          </div>

          <v-container class="px-0 py-0">
            <hb-form :label="$t(fields[key])">
              <v-col class="hb-table-value align-fields"> 

                <span v-if="key === 'available_date'">

                  <hb-date-picker
                    single-line
                    label="Enter Available Date"
                    :clearable="true"
                    :dense="true"
                    v-model="form.available_date"
                    :solo="true"
                    :flat="true"
                    v-validate="'required'"
                    id="Available Date"
                    name="Available Date"
                    data-vv-name="Available Date"
                    :error-messages="errors.collect(`Available Date`)"
                    hide-details
                    :removePaddingMargin="true"
                    :adjustForContactDetails="true"
                    ></hb-date-picker>
                </span>

                <span v-if="key === 'floor'">
                  <HbTextField
                    single-line
                    label="Enter Space Floor"
                    :clearable="true"
                    v-model="form.floor"
                    v-validate="'required|integer|min_value:-999|max_value:999'"
                    id="Space Floor"
                    name="Space Floor"
                    data-vv-name="Space Floor"
                    :error-messages="errors.collect(`Space Floor`)"
                    hide-details
                    dense
                    flat
                    solo
                  />
                </span>

                <span v-if="key === 'category_id'" class="website-category-field">
                    <v-select
                      single-line
                      :label="$t('Select Website Category')"
                      hide-details
                      :items="categories"
                      v-model="form.category_id"
                      item-value="id"
                      item-text="name"
                      v-validate="'required'"
                      id="Website Category"
                      :name="$t('Website Category')"
                      :data-vv-name="$t('Website Category')"
                      :error-messages="errors.collect($t('Website Category'))"
                    >
                  </v-select>
                </span>

                <span v-if="key === 'area_id'" class="website-category-field">
                  <HbSelect 
                      v-model="form.area_id"
                      :items="accessAreas"
                      item-text="name"
                      item-value="id"
                      placeholder="Select Access Area"
                      :loading="fetchingAreasInProgresss"
                      :disabled="fetchingAreasInProgress"
                      data-vv-name="Access Area"
                      v-validate="'required'"
                      :error="errors.has(`Access Area`)"
                    />

                    <hb-modal 
                      title="Confirm Access Area Changes"    
                      v-model="showAccessAreaConfirmation" 
                      size="medium"
                      @close="showAccessAreaConfirmation = false"
                      content-padding
                      confirmation
                    >
                        <template v-slot:content>
                            <div class="hb-text-light hb-font-body">Updating the spaces will set Tenants to the default Access Hour{{ formattedHourName }} for the Access Area. Are you sure you would like to continue?</div>
                            <div class="hb-text-light hb-font-body-medium">Are you sure you would like to continue?</div>
                        </template>
                        <template v-slot:right-actions>
                            <hb-btn 
                                color="primary" 
                                @click="save(true)"
                            >
                                Update
                            </hb-btn>       
                        </template>
                    </hb-modal>
                </span>

                <span v-if="key === 'description'">
                  <v-textarea
                    single-line
                    label="Enter description"
                    dense
                    flat
                    hide-details
                    v-model="form.description"
                    class="custom-v-textarea-wrapper"
                  ></v-textarea>
                </span>

                <span v-if="key === 'featured'">
                  <v-radio-group
                      dense
                      flat
                      hide-details
                      v-model="form.featured" :mandatory="true" row>
                      <v-radio hide-details dense label="Yes" :value="1"></v-radio>
                      <v-radio hide-details dense label="No" :value="0"></v-radio>
                  </v-radio-group>
                </span>

                <span v-if="key === 'product_id'">
                  <v-select
                    single-line
                    label="Choose Product"
                    dense
                    flat
                    hide-details
                    :items="products"
                    v-model="form.product_id"
                    item-value="id"
                    item-text="name"
                    v-validate="'required'"
                  >
                  </v-select>
                </span>
              
                <span v-if="key === 'activate'">
                  <!-- Added by BCT -->
                  <hb-radio-group
                      v-model="form.activate"
                      id="activeDeactive"
                      name="activeDeactive"
                      data-vv-name="activeDeactive"
                      data-vv-as="activeDeactive"
                      :error-messages="errors.collect('activeDeactive')"
                      v-validate="'required'"
                      hide-details
                    >
                      <hb-radio :value="1">
                        <template v-slot:label>
                          Activate Spaces
                        </template>
                      </hb-radio>
                      <hb-radio :value="0">
                        <template v-slot:label>
                          Deactivate Spaces
                        </template>
                      </hb-radio>
                    </hb-radio-group>
                    <hb-modal
                        confirmation
                        v-if="showActivateConfirmation"
                        v-model="showActivateConfirmation"
                        size="medium"
                        :title="`${form.activate ? 'Activate': 'Deactivate'} Spaces`"
                        :footerCancelOption="false"
                        @close="showActivateConfirmation = false"
                        show-help-link
                      >
                        <template v-slot:content>
                          <div class="pa-6">
                            {{`${form.activate ? 'Activating': 'Deactivating'} the spaces will ${form.activate ? 'add': 'remove'} all selected spaces ${form.activate ? 'to': 'from'} the available inventory.`}}
                          </div>
                          <div class="pl-6 pb-6">
                            {{`Are you sure you want to ${form.activate ? 'activate': 'deactivate'} all the selected spaces?`}}
                          </div>
                        </template>
                        <template v-slot:right-actions>
                          <hb-btn @click="activateDeactivateSpaces()" color="primary">{{`${form.activate ? 'Activate': 'Deactivate'} ${getBulkUnitIds.length || items.length} Space${items.length > 1 ? 's' : ''}`}}</hb-btn>
                        </template>
                    </hb-modal>
                </span>
              </v-col>
            </hb-form>
          </v-container>
      </v-card>

      <div class="bottom-bar-position">
        <hb-bottom-action-bar @close="back()">
          <template v-slot:right-actions>
            <hb-btn color="primary" :disabled="!key" @click="save">Save</hb-btn>
          </template>
        </hb-bottom-action-bar>
      </div>
    </div>

  </div>


</template>

<script>
    import api from '../../../assets/api.js';
    import HbDatePicker from '../../assets/HummingbirdDatepicker';
    import { EventBus } from '../../../EventBus.js';
    import { mapGetters, mapActions } from 'vuex';
    import { notificationMixin } from  '@/mixins/notificationMixin.js';

    export default {
        name: "BulkEditUnitDetails",
        data() {
            return {
              fetchingLevelsInProgress: false,
              fetchingAreasInProgress: false,
              showAccessAreaConfirmation: false,
              showStatusConfirmation: false,
              showActivateConfirmation: false,
              show_dialog: false,
              units: [],
              products: [],
              categories:[],
              accessAreas: [],
              key: '',
              form:{
                  available_date: '',
                  category_id: '',
                  description: '',
                  featured: '',
                  product_id: '',
                  width: '',
                  length: '',
                  height: '',
                  floor: '',
                  activate: ''
              },
              fields:{
                available_date: 'Available Date',
                category_id: 'Website Category',
                description: 'Description',
                featured: 'Featured',
                product_id: 'Rent Product',
                activate: 'Activate / Deactivate',
                floor: 'Space Floor',
                area_id: 'Area'
              }
            }
        },
        props: ['items', 'selected'],
        mixins:[ notificationMixin],
        created(){

            this.getUnitDetails();
            this.fetchCategories();
            this.fetchProducts();
            this.fetchAccessAreas();
            this.show_dialog = true;
            // Added by BCT
            this.key = this.selected.field;
        },
        components: {
            HbDatePicker
        },
        computed:{
            ...mapGetters({
                bulk_edit_items: 'bulkEditStore/items',
                properties: "propertiesStore/filtered",
                getBulkUnitIds: 'reportStore/getBulkUnitsList',
            }),
            sections(){
                return [...new Set(this.config.columns.map(({ group }) => group))]
            },
            all_storage(){
                return this.units.filter(u => u.type === 'storage').length === this.units.length;
            },
            all_residential(){
                return this.units.filter(u => u.type === 'residential').length === this.units.length;
            },
            all_parking(){
                return this.units.filter(u => u.type === 'parking').length === this.units.length;
            },
            all_pod(){
                return this.units.filter(u => u.type === 'pod').length === this.units.length;
            },
            formattedHourName(){
              let formattedName = "";
              if (this.form?.area_id && this.accessAreas?.length) {
                let currentArea = this.accessAreas.find((element) => element.id == this.form.area_id)
                let accessHourName = currentArea?.default_vendor_access_level_name;
                if (accessHourName) formattedName = " (" + accessHourName + ")"
              }
              return formattedName;
            }
        },
        methods:{
            ...mapActions({
                resetAction: 'bulkEditStore/resetAction',
                addBulkUnits: 'reportStore/addBulkUnits',
            }),
            closeWindow(){
                this.resetAction();
            },
            fetchProducts(){
                api.post(this, api.PRODUCTS + 'search', {types: ['rent']}).then(r => {
                    this.products = r.products;
                });
            },
            fetchCategories(){
                api.get(this, api.CATEGORIES).then(r => {
                    this.categories = r.categories;
                });
            },
            async fetchAccessAreas(){
              this.fetchingAreasInProgress = true;
              await api.get(this, api.PROPERTIES + this.properties[0].id + "/areas", {active: 1}).then(r => {
                this.accessAreas = r;
              });
              this.fetchingAreasInProgress = false;
            },
            async getUnitDetails(){
                let unit_ids = this.getBulkUnitIds.map(unit=> { return {id:unit.unit_id} }) || []
                
                let items = this.items.map(item => { return {id:item.unit_id} });
                let response = await api.post(this, api.UNITS + 'bulk-config', {unit_ids: unit_ids.length? unit_ids: items});
                this.units = response.units || [];
            },
            // Added by BCT
            async activateDeactivateSpaces() {
              let units_data = this.getBulkUnitIds.length ? this.getBulkUnitIds : this.items
               let payload = 
               {
                  "deactivate": !this.form.activate,
                  "units": units_data.map(unit => ({id: unit.unit_id, status: unit.unit_status})),
                  "propertyId": this.properties[0].id
              }
              let spacesNumbers = units_data.map(a => a.number);
              await api.put(this, api.ACTIVATE_DEACTIVATE_SPACES, payload).then(r => {
                  let desc = `Spaces ${spacesNumbers.join(', ')} have been ${this.form.activate ? 'Activated' : 'Deactivated'}.`;
                  this.showMessageNotification({type: 'success', description: desc});
              }).catch(err => {
                let errList = [];
                let errMsg = err;
                if (err.leased && err.leased.length) {
                    errList = err.leased;
                    errMsg = err.message;
                }
                this.showMessageNotification({type: 'error', description: errMsg, list: errList});
              })
              this.showActivateConfirmation = false;
              EventBus.$emit('unit_edited');
              this.$emit('cancel');
            },
            async save(statusConfirmed){
                let units_data = this.getBulkUnitIds.length ? this.getBulkUnitIds : this.items
                let spacesNumbers = units_data.map(a => a.number);
                let status = await this.validate(this)
                if (!status) return;
                if(this.key === 'activate') {
                  this.showActivateConfirmation = true;
                  return;
                } else if(this.key === 'area_id' && !statusConfirmed) {
                  this.showAccessAreaConfirmation = true;
                  return;
                }
                let data = {
                    unit_ids: units_data.map(item => {
                      return {
                        id: item.unit_id
                      }
                    }),
                    form: {}
                };
                data.form[this.key] = this.form[this.key];
                let response = await api.put(this, api.UNITS + 'bulk-edit', data ).catch(err => {
                  this.showMessageNotification({type: 'error', description: err});

                })
                if(!response) return;
                //Added by BCT
                if (this.key === 'area_id') {
                  if (data?.form?.area_id) {
                    const payload = {
                    type: 'bulk_space_area_change',
                    title: 'Updating Spaces',
                    persistent: true,
                    loading: true,
                    description: 'Please wait while we update the Access Area for the Spaces.'
                  }
                  this.showMessageNotification(payload)
                  }
                } else {
                  let msg = `Spaces ${spacesNumbers.join(', ')} have been updated.`
                  this.showMessageNotification({type: 'success', description: msg});
                  EventBus.$emit('unit_edited');
                }
                this.$emit('cancel');
                this.addBulkUnits([]);    
            },
            // Added by BCT
            back() {
              this.$emit('cancel');
            },

        },
        // Added by BCT
        watch: {
          "errors.items"(val) {
            if(val && val.length) {
              if (val[0].field === "Status" && val[0].rule === "required" ) {
                  val[0].msg = "Available / Offline is missing a selected value."
              }
              else if (val[0].field === "activeDeactive" && val[0].rule === "required" ) {
                  val[0].msg = "Activate / Deactivate is missing a selected value."
              }
              let desc = 'There are errors in your form, correct them before continuing.';
              this.showMessageNotification({type: 'error', description: desc, list: val});
            }
          }
        }
    }

</script>

<style scoped lang="scss">
  .align-fields {
    padding-top : 0px;
    padding-left: 0px;
    padding-bottom: 0px;
  }

  .website-category-field {
    .v-select {
      padding-top: 7px !important;
    }
  }

  .bottom-bar-position {
    position: relative;
    top: 4px;
  }
</style>